import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PageModalTable" }

import LfTable from '@/components/LfTable.vue'
import { ref, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageModalTable',
  props: {
    defaultInfo: { default: {} },
    contentTableConfig: {},
    dataList: {},
    dataCount: {},
    title: {},
    width: {},
    watchDeep: { type: Boolean }
  },
  emits: ["sortChange"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const pageInfo = ref({ pageNo: 1, pageSize: 10 })
const dialogVisible = ref(false)
const isBatch = ref(false)
const isAdd = ref(false)
const props = __props

const getPageList = (dataList: []) => {
  const currentPage = pageInfo.value.pageNo
  const pageSize = pageInfo.value.pageSize
  const startIndex = (currentPage - 1) * pageSize
  // 计算结束索引
  const endIndex = Math.min(startIndex + pageSize, dataList.length)
  // 截取当前页数据
  return dataList.slice(startIndex, endIndex)
}

const emit = __emit

//定义列表里的其他插槽
const otherPropSlots = props.contentTableConfig.propList.filter((item: any) => {
  if (item.slotName == 'createdTime') return false
  if (item.slotName == 'updatedTime') return false
  if (item.slotName == 'handler') return false
  return true
})

const handleSortChange = (value: any) => {
  emit('sortChange', value)
}

const confirmLoading = ref(false)

__expose({
  dialogVisible,
  confirmLoading,
  isBatch,
  isAdd
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: _ctx.title,
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      width: _ctx.width ? _ctx.width : '70%',
      center: "",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header", {
          row: props.defaultInfo
        }),
        _createVNode(LfTable, _mergeProps({
          listData: getPageList(_ctx.dataList),
          listCount: _ctx.dataCount,
          onSortChange: handleSortChange
        }, _ctx.contentTableConfig, {
          page: pageInfo.value,
          "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo).value = $event))
        }), _createSlots({
          createdTime: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(scope.row.createdTime)), 1)
          ]),
          updatedTime: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(scope.row.updatedTime)), 1)
          ]),
          _: 2
        }, [
          _renderList(_unref(otherPropSlots), (item) => {
            return {
              name: item.slotName,
              fn: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, item.slotName, {
                  row: scope.row
                })
              ])
            }
          })
        ]), 1040, ["listData", "listCount", "page"])
      ]),
      _: 3
    }, 8, ["title", "modelValue", "width"])
  ]))
}
}

})